import React from 'react';
import { Helmet } from 'react-helmet';

const ChemistryCalculators = () => {
  return (
    <div className="min-h-screen bg-gradient-to-r from-blue-100 to-purple-100">
      <Helmet>
        <title>Chemistry Calculators | Comprehensive Chemistry Tools</title>
        <meta name="description" content="Collection of 200+ chemistry calculators for solving complex chemical equations, conversions, solution calculations, reaction analysis, and thermodynamics." />
        <meta name="keywords" content="chemistry calculators, chemical equations, solution calculator, reaction calculator, molarity calculator, pH calculator, stoichiometry calculator" />
      </Helmet>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <div className="header-icon text-4xl text-blue-600 mb-4">⚗️</div>
          <h1 className="text-4xl font-bold text-gray-800 mb-2">Chemistry Calculators</h1>
          <p className="calculator-count text-xl text-gray-600">200+ calculators</p>
        </div>

        <div className="max-w-2xl mx-auto mb-12">
          <div className="calculator-description bg-white p-6 rounded-lg shadow-md">
            <p className="text-gray-600 mb-4">
              Discover our extensive collection of chemistry calculators that help you solve complex chemical equations and conversions. Whether you're working with solutions, analyzing reactions, or studying thermodynamics, our tools make chemistry calculations straightforward and accurate.
            </p>
            <button className="read-more inline-block bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition-colors">
              Read more
            </button>
          </div>
        </div>

        <div className="calculator-section mb-12">
          <h2 className="section-title text-2xl font-bold text-gray-800 mb-6 flex items-center">
            Solution calculators <span className="emoji ml-2">🧪</span>
          </h2>
          <div className="calculator-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="calculator-card bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
              <a href="/calculator/molarity" className="calculator-link block">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">Molarity Calculator</h3>
                <p className="text-gray-600">Calculate the concentration of solutions in moles per liter</p>
              </a>
            </div>
            <div className="calculator-card bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
              <a href="/calculator/dilution" className="calculator-link block">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">Solution Dilution Calculator</h3>
                <p className="text-gray-600">Calculate concentrations after diluting solutions</p>
              </a>
            </div>
            <div className="calculator-card bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
              <a href="/calculator/mass-percent" className="calculator-link block">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">Mass Percent Calculator</h3>
                <p className="text-gray-600">Calculate the mass percentage of solutions</p>
              </a>
            </div>
          </div>
        </div>

        <div className="calculator-section">
          <h2 className="section-title text-2xl font-bold text-gray-800 mb-6 flex items-center">
            Reaction calculators <span className="emoji ml-2">⚛️</span>
          </h2>
          <div className="calculator-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="calculator-card bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
              <a href="/calculator/stoichiometry" className="calculator-link block">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">Stoichiometry Calculator</h3>
                <p className="text-gray-600">Calculate quantities in chemical reactions</p>
              </a>
            </div>
            <div className="calculator-card bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
              <a href="/calculator/equilibrium-constant" className="calculator-link block">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">Equilibrium Constant Calculator</h3>
                <p className="text-gray-600">Calculate chemical equilibrium constants</p>
              </a>
            </div>
            <div className="calculator-card bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
              <a href="/calculator/ph" className="calculator-link block">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">pH Calculator</h3>
                <p className="text-gray-600">Calculate pH and pOH of solutions</p>
              </a>
            </div>
            <div className="calculator-card bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
              <a href="/calculator/temperature" className="calculator-link block">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">Temperature Converter</h3>
                <p className="text-gray-600">Convert between different temperature units</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChemistryCalculators;